
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/display",
      function () {
        return require("private-next-pages/system/display.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/display"])
      });
    }
  